import {
  Injectable,
  ViewContainerRef,
  TemplateRef,
  ViewRef,
  Renderer2,
  EmbeddedViewRef,
} from '@angular/core';
import { styleVariables } from '../../styles/variables';
import { AnimationService } from './animation.service';

const speedMultiplier = 1;

@Injectable()
export class AnimationUtil {
  get pageTransitionDuration() {
    return 150 / speedMultiplier;
  }

  get pageTransitionDelay() {
    return 150 / speedMultiplier;
  }

  get pageTransitionEasing() {
    return styleVariables.transitionCurveStandard;
  }
  constructor(
    public animation: AnimationService,
    private renderer: Renderer2
  ) {}

  async scaleOpacityDownTransition(node) {
    this.renderer.setStyle(node, 'pointerEvents', 'none');
    const a = await this.animation.animate({
      targets: [node],
      transform: [`scale(1)`, `scale(.97)`],
      opacity: [1, 0.32],
      fillMode: 'forwards',
      duration: styleVariables.transitionDurationShort,
      easing: styleVariables.transitionCurveStandard,
    });
    this.renderer.setStyle(node, 'pointerEvents', 'all');
    this.renderer.setStyle(node, 'opacity', 0.32);
    this.renderer.setStyle(node, 'transform', 'scale(0.97)');
    this.renderer.setStyle(node, 'pointerEvents', 'all');
    a[0].animation.destroy();
  }

  async scaleOpacityNormalTransition(node) {
    const a = await this.animation.animate({
      targets: [node],
      transform: [`scale(.97)`, `scale(1)`],
      opacity: [0.32, 1],
      fillMode: 'forwards',
      duration: styleVariables.transitionDurationShort,
      easing: styleVariables.transitionCurveStandard,
    });
    this.renderer.setStyle(node, 'pointerEvents', 'all');
    this.renderer.setStyle(node, 'opacity', 1);
    this.renderer.setStyle(node, 'transform', 'scale(1)');
    this.renderer.setStyle(node, 'pointerEvents', 'all');
    a[0].animation.destroy();
  }

  async pageTransition(from, to, opts) {
    this._preAnimationStyles_From(from, opts.forward);
    this._preAnimationStylesSetion_To(to, opts.forward);

    const promises = [
      this.animation
        .animate({
          targets: from,
          transform: this._getPostAnimationTransform_From(opts.forward),
          opacity: 0,
          duration: this.pageTransitionDuration,
          easing: this.pageTransitionEasing,
          fillMode: 'forwards',
        })
        .then((e: any) => {
          if (e && e.length) {
            this._postAnimationStyles_From(e[0].element);
            e[0].animation.destroy();
          }
        }),

      this.animation
        .animate({
          targets: to,
          transform: `translate(0) scale(1)`,
          opacity: [0, 1],
          duration: this.pageTransitionDuration,
          delay: this.pageTransitionDelay,
          easing: this.pageTransitionEasing,
          fillMode: 'forwards',
        })
        .then((e: any) => {
          if (e && e.length) {
            this._postAnimationStyles_To(e[0].element);
            e[0].animation.destroy();
          }
        }),
    ];

    return Promise.all(promises);
  }

  private _postAnimationStyles_To(node: HTMLElement) {
    if (!node) {
      return;
    }
    this.renderer.setStyle(node, 'position', 'relative');
    this.renderer.setStyle(node, 'transform', null);
    this.renderer.setStyle(node, 'opacity', '1');
  }

  private _preAnimationStyles_From(node: HTMLElement, forward: boolean) {
    if (!node) {
      return;
    }
    this.renderer.setStyle(node, 'position', 'absolute');
    this.renderer.setStyle(node, 'transform', 'translateX(0) scale(1)');
    this.renderer.setStyle(node, 'top', '0');
    this.renderer.setStyle(node, 'left', '0');
    this.renderer.setStyle(node, 'width', '100%');
    this.renderer.setStyle(node, 'display', 'block');
  }

  private _postAnimationStyles_From(node: HTMLElement) {
    if (!node) {
      return;
    }
    this.renderer.setStyle(node, 'display', 'none');
    this.renderer.setStyle(node, 'opacity', '0');
  }

  private _preAnimationStylesSetion_To(node: HTMLElement, forward: boolean) {
    if (!node) {
      return;
    }
    this.renderer.setStyle(node, 'position', 'relative');
    this.renderer.setStyle(
      node,
      'transform',
      this._getPreAnimationTransform_To(forward)
    );
    this.renderer.setStyle(node, 'top', '0');
    this.renderer.setStyle(node, 'left', '0');
    this.renderer.setStyle(node, 'opacity', '0');
    this.renderer.setStyle(node, 'display', 'block');
  }

  private _getPreAnimationTransform_To(forward) {
    if (forward) {
      return `translateX(32px) scale(.97)`;
    } else {
      return `translateX(-32px) scale(.97)`;
    }
  }

  private _getPostAnimationTransform_From(forward) {
    if (forward) {
      return `translateX(-32px) scale(1)`;
    } else {
      return `translateX(32px) scale(1)`;
    }
  }
}
